import { combineReducers } from "redux";

import { reservationDetails } from "./reducer.reservation"
const reserveReducers = combineReducers({
    reservationDetails
})
export default reserveReducers;
